import { Link } from "react-router-dom";
import { BRANDS, PRODUCTS } from "../data/store";
import { ProductCard } from "../components/ProductCard";

export default function BrandsPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 mt-6">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight uppercase mb-2" data-testid="brands-page-title">Zīmoli</h1>
      <p className="text-sm text-[#6B6B6B] mb-8 max-w-2xl">Sadarbojamies tikai ar pārbaudītiem ražotājiem, lai nodrošinātu stabilu kvalitāti gan uzņēmumiem, gan mājsaimniecībām.</p>
      <div className="space-y-10">
        {BRANDS.map((b) => {
          const prods = PRODUCTS.filter((x) => x.brand.toLowerCase().startsWith(b.name.split(" ")[0].toLowerCase())).slice(0, 4);
          return (
            <section key={b.slug} id={b.slug} className="border border-[#E2E2E2] rounded-md p-6" data-testid={`brand-section-${b.slug}`}>
              <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-4">
                <span className="text-2xl font-extrabold tracking-tight text-[#111111]">{b.name}</span>
                <p className="text-sm text-[#6B6B6B]">{b.desc}</p>
              </div>
              {prods.length > 0 ? (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                  {prods.map((p) => <ProductCard key={p.id} product={p} />)}
                </div>
              ) : (
                <Link to="/" className="text-sm text-[#111111] hover:underline">Skatīt katalogu →</Link>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}
